import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

export default el => {
    const prevButton = $(el).find('[data-prev]');
    const nextButton = $(el).find('[data-next]');
    const panels = $(el).find('[data-panel]');

    const CUTOFF = 979;
    let mode = 'vertical';
    let started = false;

    let index = 0;

    const updateHorisontal = (value, d = 0.5) => {
        const currentPanel = panels.get(index);
        index += value;
        const nextPanel = panels.get(index);
        const direction = value === 1 ? 'left' : 'right';
        const duration = d;
        TweenLite.to(currentPanel, duration, {scale: 0.7, x: direction === 'left' ? '-100%' : '100%', ease: 'Cubic.easeIn'});
        TweenLite.set(nextPanel, {scale: 0.7, x: direction === 'left' ? '100%' : '-100%'});
        TweenLite.to(nextPanel, duration, {delay: duration, x: '0%', scale: 1, ease: 'Cubic.easeOut'});
    };

    const updateVertical = panel => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const offset = Math.ceil(panel.getBoundingClientRect().top + scrollTop);
        TweenLite.to(window, 0.65, {scrollTo: {y: offset, autoKill: false}, ease: Cubic.easeInOut});
    };

    const onPrev = e => {
        if (mode === 'horisontal') {
            if (index > 0) {
                updateHorisontal(-1);
            }
        } else {
            const panel = $(e.triggerTarget).parent('[data-panel]').get(0);
            updateVertical(panel.previousElementSibling);
        }
    };

    const onNext = e => {
        if (!started) {
            started = true;
            $(el).addClass('is-started');
        }
        if (mode === 'horisontal') {
            if (index < panels.length - 1) {
                updateHorisontal(1);
            }
        } else {
            const panel = $(e.triggerTarget).parent('[data-panel]').get(0);
            updateVertical(panel.nextElementSibling);
        }
    };

    const onFocusIn = e => {
        el.scrollLeft = 0;
    };

    const reset = () => {
        index = 0;
        panels.attr('style', null);
        window.scrollTo(0, 0);
    };

    const bypassSplash = () => {
        if (mode === 'horisontal') {
            updateHorisontal(1, 0.01);
        } else {
            /*const panel = panels.get(1);
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const offset = Math.ceil(panel.getBoundingClientRect().top + scrollTop);
            window.scrollTo(0, offset);*/
            // panels.eq(0).addClass('bypassed');
        }
    };

    const onResize = () => {
        if (Viewport.width > CUTOFF && mode !== 'horisontal') {
            mode = 'horisontal';
            reset();
        } else if (Viewport.width <= CUTOFF && mode !== 'vertical') {
            mode = 'vertical';
            reset();
        }
    };

    const init = () => {
        prevButton.on('click', onPrev);
        nextButton.on('click', onNext);
        panels.on('focus', onFocusIn);
        panels.on('focusin', onFocusIn);
        Viewport.on('resize', onResize);
        onResize();
        if ($(el).data('bypass')) {
            bypassSplash();
        }
    };

    const destroy = () => {
        prevButton.off('click', onPrev);
        nextButton.off('click', onNext);
        panels.off('focus', onFocusIn);
        panels.off('focusin', onFocusIn);
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FoodWasteQuiz.js